import { render, staticRenderFns } from "./VanOffline.vue?vue&type=template&id=60a6331e&scoped=true&"
import script from "./VanOffline.vue?vue&type=script&lang=js&"
export * from "./VanOffline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a6331e",
  null
  
)

export default component.exports